import { StorySection } from '../../services';
import { StoryTabType } from '../models';

export const getStorySectionByTabType = (storyTabType?: StoryTabType) => {
  switch (storyTabType) {
    case StoryTabType.storyTab1:
      return [StorySection.MIX_LIST];
    case StoryTabType.storyTab2:
      return [StorySection.MIX_LIST_2];
    case StoryTabType.storyTab3:
      return [StorySection.MIX_LIST_3];
    case StoryTabType.storyTab4:
      return [StorySection.MIX_LIST_4];
    case StoryTabType.storyTab5:
      return [StorySection.MIX_LIST_5];
    case StoryTabType.pinnedStoryTab:
      return [StorySection.PINNED];
    case StoryTabType.pinnedStoryTab2:
      return [StorySection.PINNED_2];
    case StoryTabType.pinnedStoryTab3:
      return [StorySection.PINNED_3];
    case StoryTabType.pinnedStoryTab4:
      return [StorySection.PINNED_4];
    case StoryTabType.pinnedStoryTab5:
      return [StorySection.PINNED_5];
    default:
      return;
  }
};
